<template>

<div class="row">

    <div class="col-4">
        <button @click='approveDelivery' class='btn btn-secondary btn-block' v-if='delivery.status == 0'>
            Приеми работата 
        </button>
    </div>

    <div class="col-4">
        <button @click='open(1)' class='btn btn-primary btn-block' v-if='delivery.status == 0'>
           Върни за корекции
        </button>
    </div>

    <div v-if='canDecline' class="col-4">
        <button @click='open(2)' class='btn btn-danger btn-block' v-if='delivery.status == 0'>
           Откажи работата
        </button>
    </div>


    <div class="modal" id="pdm">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">

                <div class="modal-header">
                    <h4 class="modal-title">
                       {{ method == '1' ? "Връщане за корекции" : "Отхвърляне на изпълнението" }}
                    </h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div v-if='method == 1' class="col-12">
                            <label for='days'>Колко дни ще получи изпълнителя за корекциите :</label>
                            <input id='days' class='form-control' type='number' v-model.number='days'/>
                        </div>
                        <div class="col-12">
                            <label for='message'>Съобщение до изпълнителя : </label>
                            <textarea id='message' class='form-control' v-model='message'>
                                
                            </textarea>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    
                    <button v-if='method == 1' type="button" @click='returnForCorrections' class="btn btn-primary">
                        Върни за корекции
                    </button>
                    
                    <button v-if='method == 2' type="button" @click='declineDelivery' class="btn btn-danger">
                        Отхвърли работата
                    </button>

                    <button type="button" class="btn btn-danger" data-dismiss="modal">Затвори</button>
                </div>

            </div>
        </div>
    </div>

</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {
            
            if( typeof this.conf == 'object' ) {
                if( this.conf.canDecline === false ) {
                    this.canDecline = false;
                }
            }

        },

        props : ['delivery','conf','pp'],

        data() {
            return {
                isReady : false,
                canDecline : true,
                method  : 1, //1 - Return for corrections, 1 - Decline Delivery
                message : '',
                days    : 1,
            }
        },

        methods : {

            open( method ) {
                
                this.method = method;
                this.message = '';
                this.days    = 1;

                $("#pdm").modal('show');

            },

            check() {

                if( this.method == 1 ) {
                    
                    if( this.days < 1 ) {
                        $.notify('Моля въедете брой дни за корекциите','warning');
                        return false;
                    }

                }

                if( !this.message ) {

                    $.notify('Моля съобщение до изпълнителя','warning');
                    $("#review").focus();

                    return false;
                }

                return true;

            },

            declineDelivery() {

                if( !this.check() ) {
                    return;
                }

                var me = this;

                me.ajax.call('auc:dcd', { d : this.delivery.id, m : this.message }, (r) => {
                    
                    if( r.status == 'success' ) {

                        $("#pdm").modal('hide');
                  
                        me.$emit('decline');
                    }

                })
            },

            returnForCorrections( ) {

                if( !this.check() ) {
                    return;
                }

                var me = this;

                me.ajax.call('auc:rfc', { d : this.delivery.id, m : this.message, days : this.days }, (r) => {
                    
                    if( r.status == 'success' ) {
                        
                        $("#pdm").modal('hide');

                        me.$emit('correct', r.data.end_date);
                    }

                })
            },


            approveDelivery() {
                var me = this;

                if( !confirm("Сигурни ли сте, че искате да приемете работата на изпълнителя?") ) {
                    return;
                }


                me.ajax.call('auc:apd', { d : this.delivery.id }, (r) => {
                    
                    if( r.status == 'success' ) {

                        me.$emit('approve');
                        bus.$emit('auction-approve', me.pp.id);

                    }

                })
            },
        }

    }
</script>
